import { useState } from 'react';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);

  return (
    <section id="faq" className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            index="05"
            title="常见问题"
            subtitle="关于预告、待证实与线人隐私，先把规则讲清楚，再谈悬念。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => {
                const isOpen = openId === item.id;
                return (
                  <Reveal key={item.id} delay={index * 70}>
                    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                      <button
                        type="button"
                        onClick={() => setOpenId(isOpen ? '' : item.id)}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                      >
                        <span className="flex items-baseline gap-3">
                          <span className="font-heading text-sm font-bold text-accent-600">
                            Q{index + 1}
                          </span>
                          <span className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                            {item.question}
                          </span>
                        </span>
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-700">
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                        </span>
                      </button>
                      {isOpen && (
                        <div className="border-t border-background-200/70 px-5 pb-5 pt-4 md:px-6">
                          <p className="font-body text-sm leading-relaxed text-foreground-700">
                            {item.answer}
                          </p>
                        </div>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-4">
            <Reveal delay={120}>
              <div className="flex h-full flex-col justify-between rounded-lg border border-background-200 bg-foreground-950 p-6">
                <div>
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                    <i className="ri-mail-lock-line text-xl" />
                  </span>
                  <h3 className="mt-5 font-heading text-xl font-bold text-background-50">
                    还有别的问题？
                  </h3>
                  <p className="mt-3 font-body text-sm leading-relaxed text-background-200">
                    关于核验标准、更正流程或合作方式，都可以在预告区留言，我们会集中回复。
                  </p>
                </div>
                <a
                  href="#subscribe"
                  className="mt-8 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-3 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100"
                >
                  去订阅提醒
                  <i className="ri-arrow-right-line text-base" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}